import { SampleFields } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/sample-fields.enum';

export const rhdSampleFieldSet = [
  SampleFields.GestationAge,
  SampleFields.HumanSerumAlbuminTherapy,
  SampleFields.CellularImmunotherapy,
  SampleFields.StemCellTherapy,
  SampleFields.TransplantSurgery,
  SampleFields.BloodTransfusion,
  SampleFields.EditFieldsAvailable,
];
